const AFFILIATE_CODE_PATTERN = /^[a-z0-9_-]{3,64}$/i;

const RESERVED_REFERRAL_PATHS = new Set([
  "affiliates",
  "affiliate-program-terms",
  "api",
  "app",
  "contact",
  "discord-referrer",
  "download",
  "feature-requests",
  "features",
  "grading-plays",
  "homepage-social-preview",
  "privacy",
  "psa-10-returns",
  "psa-stats",
  "referrer",
  "reset-password",
  "share",
  "share-preview-render",
  "support",
  "terms",
  "terms-of-use",
  "unsubscribe",
]);

export function cleanReferralCode(value: string) {
  return value.trim().replace(/^evo_affiliate_code_/i, "");
}

export function normalizeReferralCode(value: string) {
  return cleanReferralCode(value).toLowerCase();
}

export function getPathReferralCode(pathname: string) {
  const trimmed = pathname.replace(/^\/+|\/+$/g, "");
  if (!trimmed || trimmed.includes("/")) return "";
  if (RESERVED_REFERRAL_PATHS.has(trimmed.toLowerCase())) return "";
  if (!AFFILIATE_CODE_PATTERN.test(trimmed)) return "";
  return cleanReferralCode(trimmed);
}

export function getReferralCodeFromLocation(location: Location) {
  const params = new URLSearchParams(location.search);
  return cleanReferralCode(
    params.get("ref") || params.get("code") || getPathReferralCode(location.pathname),
  );
}

export function getPublicReferralUrl(location: Location, code: string) {
  if (getPathReferralCode(location.pathname)) {
    return `https://evograding.com/${encodeURIComponent(code)}`;
  }
  return `https://evograding.com/?ref=${encodeURIComponent(code)}`;
}
